import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "hidden lg:block" }
const _hoisted_3 = {
  key: 0,
  class: "bg-white w-72 rounded shadow-lg absolute right-0 max-h-96 overflow-y-scroll flex flex-col gap-4 py-4"
}
const _hoisted_4 = { class: "flex items-center gap-2 px-8 mb-2" }
const _hoisted_5 = { class: "flex flex-col items-start" }
const _hoisted_6 = { class: "text-sm font-bold" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full bg-[#00000029]" }, null, -1)

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

import { useAuthStore } from "@/stores/auth";
import { AuthService } from "@/services/auth/AuthService";

import MessageModal from "../organisms/MessageModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountMenu',
  props: {
  user: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const router = useRouter();

const authStore = useAuthStore();
const authService = new AuthService();

const menuIsVisible = ref(false);
const openingMenu = ref(false);

function showMenu() {
  menuIsVisible.value = true;
}
function closeMenu() {
  menuIsVisible.value = false;
}
function clickOutside() {
  if (!openingMenu.value) {
    closeMenu();
  }
}

async function logout() {
  if (!authStore.token) return;
  const response = await authService.logout(authStore.token);
  if (response.success) {
    router.push({ name: "auth-login" });
    authStore.logout();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        class: "text-sm flex flex-row cursor-pointer text-white hover:text-light-green items-center gap-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu()))
      }, [
        _createVNode(_component_mdicon, {
          name: "account-circle",
          size: "30"
        }),
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.user.firstName) + " " + _toDisplayString(__props.user.lastName), 1)
      ])
    ]),
    (menuIsVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_mdicon, {
              name: "account-circle",
              size: "40"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.user.firstName) + " " + _toDisplayString(__props.user.lastName), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.user.email), 1)
            ])
          ]),
          _hoisted_8,
          _createElementVNode("a", {
            class: "px-8 text-left text-regular font-normal hover:text-light-green flex items-center gap-3",
            onClick: logout
          }, [
            _createVNode(_component_mdicon, {
              name: "power-standby",
              size: "20",
              class: ""
            }),
            _createTextVNode(" Cerrar sesión ")
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, clickOutside]
  ])
}
}

})